module.exports = __webpack_public_path__ + "static/media/Oro-1.bc7bfa5c.png";